




































import permissionGroup from '@/store/types/permissionGroup';
import newPermissionGroupForm from '@/components/Permissions/permissionForm.vue';
import { newPermissionGroupInterface } from '@/store/interfaces/PermissionGroup';
import { TeipNotifications } from '@/util/teipNotifications';
import { navLink } from '@/ts/navegationLinks';
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';

export default Vue.extend({
  name: 'NewPermissionGroup',
  components: {
    newPermissionGroupForm,
  },
  data: () => ({
    isLoading: true,
    navlink: [
      {
        name: 'Lista de grupo de permisos',
        active: false,
        to: '/permisos',
      },
      {
        name: 'Nuevo grupo de permisos',
        active: true,
      }
    ] as navLink[],
    render: 1,
    kind: 0,
  }),
  computed: {
    ...mapGetters({
      getPermissionSectionList: `permissionGroupModule/${permissionGroup.getters.GET_PERMISSION_SECTION_LIST}`,
    }),

  },
  async mounted() {
    await this.permissionSectionList();
    this.isLoading = false;
  },
  methods: {
    ...mapActions({
      permissionSectionList: `permissionGroupModule/${permissionGroup.actions.PERMISSION_SECTION_LIST}`,
      savePermissionSection: `permissionGroupModule/${permissionGroup.actions.SAVE_PERMISSION_GROUP}`,
    }),
    saveNewGroup(model: newPermissionGroupInterface) {
      const notification = new TeipNotifications();
      model.kind = this.kind === 1 ? 'companies' : 'staff';

      this.savePermissionSection(model)
        .then(() => {
          this.render++;
          notification.success('Permisos agregado correctamente.');
        })
        .catch(() => {
          notification.warning('Algo salió mal :( al tratar de actualizar');
        });
    },
    async kindGroup(kind: number) {
      this.kind = kind;
      await this.permissionSectionList(kind);
    },
  },
});
